
import { Table, TableBody, ButtonGroup, Modal, TableCell, TableContainer, TableHead, TableRow, AppBar, Box, Toolbar, TextField, useTheme, IconButton, Button, Menu, MenuItem, ListItemIcon, ListItemText, Typography, Divider, CssBaseline, alpha, Badge } from "@mui/material";
import { useEffect, useState } from "react";

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import ListAltIcon from '@mui/icons-material/ListAlt';
import RefreshIcon from '@mui/icons-material/Refresh';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import HelpIcon from '@mui/icons-material/HelpOutline';



import CloseIcon from '@mui/icons-material/Close';
import Close from '@mui/icons-material/Close';
import EmailIcon from '@mui/icons-material/Email';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PrintIcon from '@mui/icons-material/Print';
import DeleteIcon from '@mui/icons-material/Delete';

import { tokens } from "../../../theme/theme";


import Searchicon from '@mui/icons-material/Search';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';


import useVendorEnquieyList from "../../../hooks/useVendorEnquieyList";
import AddNewVendorEnquiry from "./AddVendorEnquiry";
import CustomTableContainer from "../../../Layout/CustomTableContainer";
import { ViewList } from "@mui/icons-material";
import PurchaseIndent from "../purchase-indent/PurchaseIndent";
import usePurchaseIndentList from "../../../hooks/usePurchaseIndentList";

const VendorEnquiry = ({ handleBackWinderMachineEntry, showPendingInProgressStatusEnquiry, QuotationMode }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    // State for first menu
    const [anchorElFirst, setAnchorElFirst] = useState(null);
    const [selectedOptionFirst, setSelectedOptionFirst] = useState('All Vendor Enquiry');

    const [selectedStatus, setSelectedStatus] = useState('All');
    const openFirst = Boolean(anchorElFirst);
    const [newRequestIndent, setNewRequestIndent] = useState(false);
    const [requestIndentHome, setRequestIndentHome] = useState(true);
    const [showPurchaseindentUI, setShowPurchaseindentUI] = useState(false);

    const [selectedRows, setSelectedRows] = useState([]);
    const [showFirstToolbar, setShowFirstToolbar] = useState(true);
    const [showNewToolbar, setShowNewToolbar] = useState(false);


    // State for second menu
    const [anchorElSecond, setAnchorElSecond] = useState(null);
    // const [selectedOptionSecond, setSelectedOptionSecond] = useState('');
    const openSecond = Boolean(anchorElSecond);

    const [anchorElMenu, setAnchorElMenu] = useState(null);
    const openMenu = Boolean(anchorElMenu);
    const [notification, setNotification] = useState(0);

    const { vendorEnquiryList, setPurchasedIIndentList, selectPurchasedIndent, selectPurchasedIndentID, loadVendorEnquiryByID, } = useVendorEnquieyList('vendor enquiry');
    const { purchasedIndentList, loadPurchasedIndentByID, } = usePurchaseIndentList('purchase indent');

    // Handlers for first menu
    const handleMenuClickFirst = (event) => {
        setAnchorElFirst(event.currentTarget);
    };

    const handleMenuCloseFirst = () => {
        setAnchorElFirst(null);
    };

    const handleMenuItemClickFirst = (option) => {
        setSelectedOptionFirst(option); // Update the selected option
        handleMenuCloseFirst();

        if (option === 'All Vendor Enquiry') {
            setSelectedStatus('All');
        }
        else if (option === 'Partially Vendor Enquiry') {
            setSelectedStatus('Partially Vendor Enquiry');
        }
        // else if (option === 'Un Approved Request Indent') {
        //     setSelectedStatus('Un Approved');
        // }


        setAnchorElFirst(null);
    };

    // Handlers for second menu
    const handleMenuClickSecond = (event) => {
        setAnchorElSecond(event.currentTarget);
    };

    const handleMenuCloseSecond = () => {
        setAnchorElSecond(null);
    };

    const handleMenuItemClickSecond = (option) => {
        // setSelectedOptionSecond(option); // Update the selected option
        handleMenuCloseSecond();
    };

    const [editIssueIndentID, setEditIssueIndentID] = useState(0);
    const [enquirystatus, setEnquirystatus] = useState(0);
    const handleShowNewVendor = () => {
        setEditIssueIndentID(0);
        setRequestIndentHome(false);
        setNewRequestIndent(true);
        setShowPurchaseindentUI(false);
    }

    const handleCallEdit = (value, poID, poNumber) => {
        setEditIssueIndentID(value.id_enquiry);
        setEnquirystatus(value.status);
        setRequestIndentHome(false);
        setNewRequestIndent(true);
        setShowPurchaseindentUI(false);
    };

    const handlecallback = () => {
        setRequestIndentHome(true);
        setNewRequestIndent(false);
        setShowPurchaseindentUI(false);
        loadVendorEnquiryByID();
        loadPurchasedIndentByID();

    }






    const [open, setOpen] = useState(false);
    const [filters, setFilters] = useState({
        material_code: '',
        remarks: '',
        status: '',
        purchase_indent_number: '',
        enquiry_date: '',
    });

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        setFilters({ ...filters, [name]: value });
    };






    const isSelected = (rowId) => selectedRows.indexOf(rowId) !== -1;



    // const filteredData = vendorEnquiryList.filter((row) => {
    //     // Check if row matches selected status
    //     if (selectedStatus === 'All' || row.status === selectedStatus) {
    //         // Check if all filter fields match
    //         return Object.keys(filters).every((key) => {
    //             if (filters[key] === '') return true; // No filter applied
    //             return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
    //         });
    //     }
    //     return false;
    // });

    const filteredData = vendorEnquiryList.filter((row) => {
        // 🔒 Force Approved only when toggle is ON
        if (showPendingInProgressStatusEnquiry && row.status !== 'Pending' && row.status !== 'In Progress') {
            return false;
        }

        // Existing status filter logic
        if (selectedStatus !== 'All' && row.status !== selectedStatus) {
            return false;
        }

        // Text filters
        return Object.keys(filters).every((key) => {
            if (!filters[key]) return true;
            return String(row[key])
                .toLowerCase()
                .includes(filters[key].toLowerCase());
        });
    });

    const handleNewToolbarClose = () => {
        setShowNewToolbar(false); // Hide new toolbar
        setShowFirstToolbar(true);
    };

    const handleBulkUpdate = () => {
        console.log('Bulk Update');
    };

    const handleMarkAsIssued = () => {
        console.log('Mark as Issued');
    };

    const handleBulkCancelItems = () => {
        console.log('Bulk Cancel Items');
    };

    const handleBulkReopenCancelledItems = () => {
        console.log('Bulk Reopen Cancelled Items');
    };

    const handleConvertToBill = () => {
        console.log('Convert to Bill');
    };

    const handleShowPurchaseIndentList = () => {
        setRequestIndentHome(false);
        setNewRequestIndent(false);
        setShowPurchaseindentUI(true);
    }

    useEffect(() => {
        const createdCount = purchasedIndentList.filter(
            item => item?.status === "Created"
        ).length;

        setNotification(createdCount);
    }, [purchasedIndentList]);


    return (
        <Box >
            <CssBaseline />
            {requestIndentHome && (

                <AppBar position="static" sx={{ backgroundColor: "inherit", borderRadius: "0px", height: "48px", justifyContent: "center" }}>
                    <Toolbar>
                        {/* First Menu */}
                        {showFirstToolbar && (
                            <>
                                <Button
                                    color="secondary"
                                    onClick={handleMenuClickFirst}
                                    endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: "18px" }} />}
                                    sx={{ textTransform: 'none', fontSize: "16px", fontWeight: "500" }}
                                >
                                    {selectedOptionFirst}
                                </Button>
                                <Menu
                                    anchorEl={anchorElFirst}
                                    open={openFirst}
                                    onClose={handleMenuCloseFirst}

                                >
                                    <MenuItem onClick={() => handleMenuItemClickFirst('All Vendor Enquiry')}>All </MenuItem>
                                    <MenuItem onClick={() => handleMenuItemClickFirst('Partially Vendor Enquiry')}>Partially Vendor Enquiry</MenuItem>
                                    {/* <MenuItem onClick={() => handleMenuItemClickFirst('Un Approved Request Indent')}>Un Approved Request</MenuItem> */}

                                </Menu>
                                {!QuotationMode && (
                                    <Button size="small" variant="contained" onClick={handleShowPurchaseIndentList} color="secondary"
                                        startIcon={
                                            <Badge
                                                badgeContent={notification}
                                                color="error"
                                                overlap="circular"
                                                sx={{
                                                    "& .MuiBadge-badge": {
                                                        fontSize: "10px",
                                                        height: "16px",
                                                        minWidth: "16px",
                                                        padding: "0 4px",
                                                    },
                                                }}
                                            >
                                                <ViewList sx={{ fontSize: "18px" }} />
                                            </Badge>
                                        } sx={{ marginLeft: 'auto', textTransform: 'none', marginRight: '5px' }}>
                                        View Purchase Indent list
                                    </Button>
                                )}
                                {/* Adding margin-left: auto to push the button to the right */}
                                {/* <Button size="small" variant="contained" onClick={handleShowNewVendor} color="secondary" startIcon={<AddIcon sx={{ fontSize: "18px" }} />}>New</Button> */}

                                {/* Second Menu */}
                                <IconButton
                                    size="small"
                                    // edge="start"
                                    color="secondary"
                                    aria-label="menu"
                                    sx={{ ml: QuotationMode ? "auto" : 2 }}
                                    onClick={handleMenuClickSecond}
                                >
                                    <MoreVertIcon sx={{ fontSize: "18px" }} />
                                </IconButton>
                                <Menu
                                    anchorEl={anchorElSecond}
                                    open={openSecond}
                                    onClose={handleMenuCloseSecond}
                                >
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Import Vendor Enquiry')}>
                                        <ListItemIcon>
                                            <ImportExportIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Import Vendor Enquiry" />
                                    </MenuItem>
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Export Vendor Enquiry')}>
                                        <ListItemIcon>
                                            <FileDownloadIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Export Vendor Enquiry" />
                                    </MenuItem>
                                    <Divider />
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Preference List')}>
                                        <ListItemIcon>
                                            <ListAltIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Preference " />
                                    </MenuItem>
                                    <Divider />
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Refresh List')}>
                                        <ListItemIcon>
                                            <RefreshIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Refresh List" />
                                    </MenuItem>
                                    <Divider />
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Reset Column Width')}>

                                        <Button variant="contained" color="secondary" size="small" startIcon={<FormatAlignJustifyIcon />}>
                                            Reset Columns Width
                                        </Button>
                                    </MenuItem>
                                </Menu>

                                <IconButton
                                    size="small"
                                    // edge="start"
                                    // color="inherit"
                                    aria-label="menu"
                                    sx={{ mr: 1, ml: 1 }}
                                    onClick={handleMenuClickSecond}
                                >
                                    <HelpIcon sx={{ fontSize: "18px" }} />
                                </IconButton>
                                <div>
                                    <IconButton onClick={handleBackWinderMachineEntry} >
                                        <Close fontSize="inherit" style={{ color: "#2196F3", fontSize: "18px" }} />
                                    </IconButton>
                                </div>
                            </>
                        )}

                        {showNewToolbar && (
                            <>
                                <Button
                                    variant="outlined"
                                    color="secondary"

                                    onClick={handleMenuClickFirst}
                                    endIcon={<ArrowDropDownIcon sx={{ color: "teal" }} />}
                                    sx={{ textTransform: 'none', fontSize: "10px", fontWeight: "bold" }}
                                >
                                    {/* {selectedOptionFirst} */}
                                    <Typography variant="h6">
                                        Bulk Updates
                                    </Typography>
                                </Button>
                                <Menu
                                    anchorEl={anchorElFirst}
                                    open={openFirst}
                                    onClose={handleMenuCloseFirst}

                                >
                                    <MenuItem onClick={() => handleBulkUpdate()}>Bulk Update </MenuItem>
                                    <MenuItem onClick={() => handleMarkAsIssued()}>Mark as Issued</MenuItem>
                                    <MenuItem onClick={() => handleBulkCancelItems()}>Bulk Cancel Items</MenuItem>
                                    <MenuItem onClick={() => handleBulkReopenCancelledItems()}>Bulk reopen Canceled items</MenuItem>
                                    <MenuItem onClick={() => handleConvertToBill()}>Convert to Bill</MenuItem>
                                    {/* <MenuItem onClick={() => handleMenuItemClickFirst('Billed Purchase Orders')}>Billed</MenuItem> */}
                                </Menu>



                                <ButtonGroup color="secondary" variant="outlined" style={{ marginLeft: 10 }}>
                                    <Button aria-label="email" sx={{ padding: "6px", minWidth: 40 }}>
                                        <EmailIcon style={{ fontSize: "20px", color: "#5c6bc0" }} />
                                    </Button>
                                    <Button aria-label="pdf" sx={{ padding: 0, minWidth: 40 }}>
                                        <PictureAsPdfIcon style={{ fontSize: "20px", color: "#d32f2f" }} />
                                    </Button>
                                    <Button aria-label="print" sx={{ padding: 0, minWidth: 40 }}>
                                        <PrintIcon style={{ fontSize: "20px", color: "#64b5f6" }} />
                                    </Button>
                                </ButtonGroup>
                                <ButtonGroup color="secondary" variant="outlined" style={{ marginLeft: 10 }}>
                                    <Button aria-label="delete" sx={{ padding: "6px", minWidth: 40 }}>
                                        <DeleteIcon style={{ fontSize: "20px", color: "#ff7043" }} />
                                    </Button>
                                </ButtonGroup>
                                <IconButton size="small" aria-label="close" sx={{ marginLeft: 2 }} >
                                    <FiberManualRecordIcon sx={{ fontSize: "12px", color: "green" }} />
                                </IconButton>
                                <Typography variant="h6" >
                                    {`${selectedRows.length} Purchase Order${selectedRows.length > 1 ? 's' : ''} selected`}
                                </Typography>


                                <IconButton size="small" aria-label="close" sx={{ marginLeft: 'auto', mr: 1 }} onClick={handleNewToolbarClose}>
                                    <CloseIcon />
                                </IconButton>
                            </>
                        )}




                    </Toolbar>
                </AppBar>



            )}

            {requestIndentHome && (

                <CustomTableContainer colors={colors}>
                    <TableContainer >
                        <Table size="small">
                            <TableHead sx={{ backgroundColor: colors.primary[400] }}>
                                <TableRow>

                                    {/* <TableCell>ENQUIRY ID</TableCell> */}
                                    <TableCell>PURCHASE INDENT #</TableCell>
                                    <TableCell>ENQUIRY DATE</TableCell>
                                    <TableCell>STATUS</TableCell>
                                    <TableCell>REMARKS</TableCell>

                                    <TableCell>
                                        <IconButton onClick={handleOpen}>
                                            <Searchicon style={{ fontSize: "16px" }} />
                                        </IconButton>
                                        <Modal
                                            open={open}
                                            onClose={handleClose}
                                            aria-labelledby="modal-modal-title"
                                            aria-describedby="modal-modal-description"
                                        >
                                            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>

                                                <TextField
                                                    label="Purchase Indent #"
                                                    name="purchase_indent_number"
                                                    value={filters.purchase_indent_number}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    size="small"
                                                    margin="normal"
                                                    color="secondary"
                                                />


                                                <TextField
                                                    label="Status"
                                                    name="status"
                                                    value={filters.status}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                    size="small"
                                                    color="secondary"
                                                />

                                                <TextField
                                                    label="Remarks"
                                                    name="remarks"
                                                    value={filters.remarks}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                    size="small"
                                                    color="secondary"
                                                />


                                                <Button variant="contained" onClick={handleClose} style={{ marginTop: 10 }}>
                                                    Apply Filter
                                                </Button>
                                            </Box>
                                        </Modal>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredData.map((row, index) => (
                                    <TableRow key={row.id_enquiry} sx={{
                                        backgroundColor: index % 2 === 0 ?
                                            theme.palette.background.default : alpha(theme.palette.action.hover, 0.03),
                                    }}>



                                        <TableCell>
                                            <span
                                                style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                onClick={() => handleCallEdit(row)}
                                            >
                                                {row.purchase_indent_number}
                                            </span>
                                        </TableCell>
                                        <TableCell>{row.enquiry_date}</TableCell>
                                        <TableCell>{row.status}</TableCell>


                                        <TableCell>{row.remarks}</TableCell>

                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </CustomTableContainer>
            )}


            {/* New Vendor */}
            {newRequestIndent && (
                <>
                    <AddNewVendorEnquiry handlecallback={handlecallback}
                        editIssueIndentID={editIssueIndentID} selectedMode={0} enquirystatus={enquirystatus} />
                </>

            )}

            {showPurchaseindentUI && (
                <>
                    <PurchaseIndent handleBackWinderMachineEntry={handlecallback} showOnlyNewPurchaseIndent={true} enquiryMode={true} />
                </>
            )}



        </Box>
    );
}

export default VendorEnquiry;





